import ClientService from '../../services/client-service';
import getContactDataQuery from '../../graphql/query/get-contact-data.graphql';
import getContactUserDataQuery from '../../graphql/query/get-contact-user-data.graphql';
import getContactVCardDataQuery from '../../graphql/query/get-contact-vcard-data.graphql';
import getContactRelatedContactListDataQuery from '../../graphql/query/get-contact-related-contact-list-data.graphql';
import getContactDealListDataQuery from '../../graphql/query/get-contact-deal-list-data.graphql';
import saveContactDataMutation from '../../graphql/mutation/save-contact-data.graphql';
import deleteContactCommentMutation from '../../graphql/mutation/delete-contact-comment.graphql';
import saveContactCommentMutation from '../../graphql/mutation/save-contact-comment.graphql';

export default class ContactApi {
  public static getContactData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getContactDataQuery, payload);
  }

  public static getContactUserData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getContactUserDataQuery, payload);
  }

  public static getContactVCardData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getContactVCardDataQuery, payload);
  }

  public static getContactRelatedContactListData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getContactRelatedContactListDataQuery, payload);
  }

  public static getContactDealListData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getContactDealListDataQuery, payload);
  }

  public static saveContactData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(saveContactDataMutation, payload);
  }

  public static deleteContactComment(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(deleteContactCommentMutation, payload);
  }

  public static saveContactComment(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(saveContactCommentMutation, payload);
  }
}
